export default "__VITE_ASSET__C_HaPLpj__"